@if (hasHeader) {
  <table class="table table--responsive mb-0">
    <thead class="c-table-head-text">
      <tr>
        <th scope="col" class="text-left">{{ 'cartItems.item' | cxTranslate }}</th>
        @if (isOrderDetails) {
          <th>{{ 'cartAdministration.cartItems.status' | cxTranslate }}</th>
        }
        <th scope="col">{{ 'cartItems.quantity' | cxTranslate }}</th>
        <th scope="col">{{ 'cartAdministration.cartItems.available' | cxTranslate }}</th>
        <th scope="col">{{ 'cartAdministration.cartItems.deliveryDate' | cxTranslate }}</th>
        <th scope="col">{{ 'cartAdministration.cartItems.warehouse' | cxTranslate }}</th>
        <th scope="col">{{ 'cartAdministration.cartItems.noReturnPolicy.label' | cxTranslate }}</th>
        @if (!isOrderDetails) {
          <th>
            @if (!fromConfigurator) {
              <span>{{ 'cartItems.itemPriceRrp' | cxTranslate }}</span>
            } @else {
              <span>{{ 'cartItems.itemPrice' | cxTranslate }}</span>
            }
          </th>
        }
        @if (isOrderDetails) {
          <th>{{ 'cartItems.itemPrice' | cxTranslate }}</th>
        }
        @if (options.isSaveForLater) {
          <th scope="col">
            {{ 'saveForLaterItems.stock' | cxTranslate }}
          </th>
        } @else {
          <th scope="col">
            {{ 'cartItems.total' | cxTranslate }}
          </th>
        }
        @if (!readonly) {
          <th scope="col" colspan="2"></th>
        }
      </tr>
    </thead>
    <tbody>
      @for (item of items; track trackItemByFn(i, item); let i = $index) {
        <ng-container class="cx-item-list-row">
          @if (getControl(item) | async; as control) {
            <ng-container
              class="cx-item-list-items"
                  [class.is-changed]="
          featureConfigService?.isLevel('3.1')
            ? control.get('quantity').disabled
            : control.get('quantity').dirty">
              @if (!item.subEntry) {
                <app-efa-cart-item [ngClass]="{'has-subentries' : !isOrderDetails && item.parent}"
                  [item]="item"
                  [quantityControl]="control.get('quantity')"
                  [readonly]="readonly"
                  [fromConfigurator]="fromConfigurator"
                  [promotionLocation]="promotionLocation"
                  [options]="options"
                  [isOrderDetails]="isOrderDetails"
                  (consignmentChange)="getValue($event, item.entryNumber, 'consignmentInfo', i)"
                  (consignmentEditableChange)="onConsignmentEditableChange($event, item.uniqueIdentifier)"
                  (consignmentFocusedChange)="onConsignmentFocusedChange($event, item.uniqueIdentifier)"
                  (consignmentFormCreated)="onConsignmentFormCreated($event, item.entryNumber, i, item.uniqueIdentifier)"
                ></app-efa-cart-item>
              }
              @if (item.subEntries?.length > 0) {
                <app-cart-sub-entry [subEntries]="item.subEntries"></app-cart-sub-entry>
              }
              <!-- Item Consignment -->
              @if ((!readonly || options.isSaveForLater) && item.updateable && consignmentEditable.get(item.uniqueIdentifier) && consignmentForm.get(item.uniqueIdentifier)) {
                <div class="consignment-info ml-lg-2"
                  [formGroup]="consignmentForm.get(item.uniqueIdentifier)">
                  <div class="input-block d-flex">
                    <input type="text"
                      [maxLength]="consignmentInfoAllowedMaxLength"
                      formControlName="consignmentInfo"
                      appEfaAutoFocus [focus]="consignmentFocused.get(item.uniqueIdentifier)"
                      class="form-control mr-2"
                      placeholder="{{ 'cartAdministration.cartProductSearchForm.consignmentInfo.placeholder' | cxTranslate }}">
                      @if ((cartEntryInfosUpdating$| async) && (currentCartEntryNumberUpdating$ | async) === item.entryNumber && (currentCartEntryInfoTypeUpdating$ | async) === 'consignmentInfo') {
                        <cx-icon
                        type="SPINNER"></cx-icon>
                      }
                    </div>
                    <cx-form-errors [control]="consignmentForm.get(item.uniqueIdentifier).get('consignmentInfo')"></cx-form-errors>
                  </div>
                }
                @if (item.consignmentInfo && readonly) {
                  <div class="ml-lg-2">
                    <span class="u-font-bold">{{ 'cartAdministration.cartItems.commission' | cxTranslate }}:</span><br>
                    <span>{{ item.consignmentInfo }}</span>
                  </div>
                }
                @if (item.orderInfoFields?.length > 2) {
                  <app-order-info-fields [orderInfoFields]="item.orderInfoFields.slice(0,2)"
                    [readonly]="readonly"
                    [entryNumber]="item.entryNumber"
                    [entryKey]="item.uniqueIdentifier"
                    (OrderInfoFieldValueChange)="getValue($event, item.entryNumber, 'orderInfoFields', i)">
                  </app-order-info-fields>
                  <app-order-info-fields [orderInfoFields]="item.orderInfoFields.slice(2,item.orderInfoFields.length)"
                    [readonly]="readonly"
                    [entryNumber]="item.entryNumber"
                    [entryKey]="item.uniqueIdentifier"
                    (OrderInfoFieldValueChange)="getValue($event, item.entryNumber, 'orderInfoFields', i)">
                  </app-order-info-fields>
                  @if (isMandatoryFields(item.orderInfoFields) && !readonly) {
                    <tr class="mandatory-message">
                      <td colspan="8" class="fields-required">
                        {{ 'cartAdministration.orderInfoFields.mandatoryMessage' | cxTranslate }}
                      </td>
                    </tr>
                  }
                } @else {
                  <app-order-info-fields [orderInfoFields]="item.orderInfoFields"
                    [readonly]="readonly"
                    [entryNumber]="item.entryNumber"
                    [entryKey]="item.uniqueIdentifier"
                    (OrderInfoFieldValueChange)="getValue($event, item.entryNumber, 'orderInfoFields', i)">
                  </app-order-info-fields>
                  @if (isMandatoryFields(item.orderInfoFields) && !readonly) {
                    <tr class="mandatory-message">
                      <td colspan="8" class="fields-required">
                        {{ 'cartAdministration.orderInfoFields.mandatoryMessage' | cxTranslate }}
                      </td>
                    </tr>
                  }
                }
              </ng-container>
            }
          </ng-container>
        }
      </tbody>
    </table>
  }

